import { render, staticRenderFns } from "./DailyChallengeCalendar.vue?vue&type=template&id=954f9a62&scoped=true&"
import script from "./DailyChallengeCalendar.vue?vue&type=script&lang=ts&"
export * from "./DailyChallengeCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./DailyChallengeCalendar.vue?vue&type=style&index=0&id=954f9a62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954f9a62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('954f9a62', component.options)
    } else {
      api.reload('954f9a62', component.options)
    }
    module.hot.accept("./DailyChallengeCalendar.vue?vue&type=template&id=954f9a62&scoped=true&", function () {
      api.rerender('954f9a62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/dailyproblems/components/DailyChallengeCalendar.vue"
export default component.exports